import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ILastClickedLink } from './types';

interface LastClickedLinkState {
  lastClickedLink: ILastClickedLink | null;
}

const initialState: LastClickedLinkState = {
  lastClickedLink: null,
};

export const lastClickedLinkSlice = createSlice({
  name: 'lastClickedLink',
  initialState,
  reducers: {
    setLastClickedLink: (state, action: PayloadAction<ILastClickedLink>) => {
      state.lastClickedLink = action.payload;
    },
    clearLastClickedLink: (state) => {
      state.lastClickedLink = null;
    },
  },
});

export const { setLastClickedLink, clearLastClickedLink } = lastClickedLinkSlice.actions;
